/* eslint-disable import/no-anonymous-default-export */
export default {
  offers: {
    list: [],
    archivedOffers: [],
    loading: false,
    current: null,
    currentOfferLine: null,
    currentVKI: null,
    error: null,
    fetching: true,
  },
};
